export default __webpack_public_path__ + "static/media/Pretendard-Light.subset.b69f4316.woff2";